PlayersOfflineService.$inject = [
    '_',
    '$uibModal',
    'Club',
    'Sports',
    'Time',
    'moment',
    'alerts',
];

/* @ngInject */
export function PlayersOfflineService(
    _,
    $uibModal,
    Club,
    Sports,
    Time,
    moment,
    alerts,
) {
    this.PlayerOffline = PlayerOffline;
    this.MissingOneList = MissingOneList;
    this.open = function open(booking) {
        $uibModal.open({
            template: require('../../views/booking/players_offline.modal.html'),
            size: 'lg',
            backdrop: false,
            windowClass: 'zindex',
            controller: PlayersOfflineController,
            controllerAs: 'vm',
            bindToController: true,
            //appendTo: parentElem,
            resolve: {
                deps: {
                    booking: booking,
                },
            },
        });
    };

    function MissingOneList(API, bookingID) {
        this.loading = true;
        this.loaded = false;
        this._API = API;
        this._bookingID = bookingID;
        this.list = [];

        this.fetch = MissingOneList.fetch.bind(this);
        this.addPlayer = MissingOneList.addPlayer.bind(this);
        this.removePlayer = MissingOneList.removePlayer.bind(this);
        this.updatePlayer = MissingOneList.updatePlayer.bind(this);
    }
    MissingOneList.fetch = function () {
        var self = this;

        self.loading = true;
        self.loaded = false;

        self._API
            .customGET(`missing_one/booking/${self._bookingID}`)
            .then((res) => {
                self.loading = false;
                self.loaded = true;

                self.list = res.map(function (o) {
                    return new PlayerOffline(o);
                });
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                self.loading = true;
            });
    };

    MissingOneList.addPlayer = function (player) {
        var self = this;
        for (var _i = 0; _i < self.list.length; _i++) {
            if (self.list[_i].id === player.id) {
                alerts.error(
                    '¡Error!',
                    'El usuario ya se encuentra en la lista de jugadores!',
                );
                return;
            }
        }

        self._API
            .one(`missing_one/booking/${self._bookingID}`)
            .customPOST(player)
            .then((res) => {
                for (var _i = 0; _i < self.list.length; _i++) {
                    if (self.list[_i].id === res.id) {
                        self.list[_i] = player;
                        return;
                    }
                }
                self.list.push(player);
            })
            .catch(alerts.errorHandler)
            .finally(function () {});
    };

    MissingOneList.removePlayer = function (player) {
        var self = this;

        self._API
            .customDELETE(
                `missing_one/booking/${self._bookingID}/player_offline/${player.id}`,
                null,
            )
            .then(function (data) {
                for (var _i = 0; _i < self.list.length; _i++) {
                    if (self.list[_i].id === player.id) {
                        self.list.splice(_i, 1);
                        return;
                    }
                }
            })
            .catch(alerts.errorHandler)
            .finally(function () {});
    };

    MissingOneList.updatePlayer = function (player) {
        var self = this;
        for (var _i = 0; _i < self.list.length; _i++) {
            if (self.list[_i].id === player.id) {
                self.list[_i] = player;
                return;
            }
        }
    };

    function PlayerOffline(data) {
        this.id = 0;
        this.loaded = false;
        this.name = null;
        this.phone = null;
        this.email = null;
        this.category = null;
        this.date_of_birth = null;
        this.gender = null;
        this.created_at = null;
        this.updated_at = null;

        this.sportClub = null;

        Object.assign(this, data);

        this.date_of_birth = this.date_of_birth
            ? Time.moment(this.date_of_birth)
            : null;

        this._date_of_birth = this.date_of_birth
            ? Time.moment(this.date_of_birth).format('DD/MM/YYYY')
            : null;
        this.suggestion = `${this.name} / ${this.phone}`;
    }

    PlayerOffline.prototype.getId = function () {
        return this.id;
    };

    PlayerOffline.prototype.getDateOfBirth = function (format = null) {
        return this.date_of_birth
            ? Time.moment(this.date_of_birth).format(format)
            : null;
    };
    PlayerOffline.prototype.getCreatedAt = function () {
        return Time.moment(this.created_at);
    };
    PlayerOffline.prototype.getUpdatedAt = function () {
        return Time.moment(this.updated_at);
    };
}

PlayersOfflineController.$inject = [
    '$scope',
    '$uibModalInstance',
    'alerts',
    'deps',
    'Club',
    'PlayersOffline',
    'Time',
    'CONST',
    '_',
    '$q',
];

/* @ngInject */
export function PlayersOfflineController(
    $scope,
    $uibModalInstance,
    alerts,
    deps,
    Club,
    PlayersOffline,
    Time,
    CONST,
    _,
    $q,
) {
    var vm = this,
        MissingOneList = PlayersOffline.MissingOneList,
        PlayerOffline = PlayersOffline.PlayerOffline;

    vm.user = deps.booking.attrs.user;
    vm.bookingID = deps.booking.id;

    vm.sport = deps.booking.getSport();
    vm.players_max = vm.sport.data.players_max;

    vm.players = new MissingOneList(Club.API, vm.bookingID, vm.players_max);

    vm.playerOffline = new PlayerOffline(Club.API);
    vm.players.fetch();
    vm.phone_number_input = '';

    vm.validateInput = function () {
        const input = document.querySelector('#player_phone_create');
        const iti = intlTelInput.getInstance(input);
        if (!input.value.trim()) {
            vm.player_offline.phone = undefined;
            vm.create_booking_form.player_phone.$valid = false;
            vm.create_booking_form.player_phone.$invalid = true;
            return;
        }
        if (iti.isValidNumber()) {
            vm.player_offline.phone = iti.getNumber();
            vm.create_booking_form.player_phone.$valid = true;
            vm.create_booking_form.player_phone.$invalid = false;
            return;
        }
        vm.player_offline.phone = undefined;
        vm.create_booking_form.player_phone.$valid = false;
        vm.create_booking_form.player_phone.$invalid = true;
    };

    vm.canSave = function () {
        if (vm.player_offline.id > 0) {
            return true;
        }
        return vm.players.list.length + 1 < vm.players_max;
    };

    this.close = function () {
        $uibModalInstance.close(false);
    };

    vm.createOrResetPlayer = function () {
        vm.player_offline = new PlayerOffline({
            // type: 'player_offline',
            // phone: '+541111111112',
            // name: 'hugo',
            // date_of_birth: new Date (),
        });
        vm.phone_number_input = '';
        const input = document.querySelector('#player_phone_create');
        if (input) {
            const iti = intlTelInput.getInstance(input);
            iti.setCountry('');
        }
    };

    vm.createOrResetPlayer();

    vm.save = function () {
        var data = vm.createPostData();
        if (data.id === 0) {
            Club.API.one('players_offline')
                .customPOST(data)
                .then((res) => {
                    vm.players.addPlayer(new PlayerOffline(res));
                    this.createOrResetPlayer();
                })
                .catch(function (err) {
                    console.log(err);
                })
                .finally(function () {});
        } else {
            Club.API.one(`players_offline/${data.id}`)
                .customPUT(data)
                .then((res) => {
                    vm.players.updatePlayer(new PlayerOffline(res));
                    this.createOrResetPlayer();
                })
                .catch(function (err) {
                    console.log(err);
                })
                .finally(function () {});
        }
    };

    vm.createPostData = function () {
        if (
            vm.player_offline.date_of_birth !== null &&
            typeof vm.player_offline.date_of_birth === 'object'
        ) {
            return Object.assign({}, vm.player_offline, {
                date_of_birth: vm.player_offline.date_of_birth
                    .toISOString()
                    .split('T')[0],
            });
        }
        return Object.assign({}, vm.player_offline);
    };

    vm.remove = function (player, index) {
        vm.players.removePlayer(player);
    };

    vm.edit = function (player, index) {
        vm.player_offline = Object.assign({}, player);
        const input = document.querySelector('#player_phone_create');
        const iti = intlTelInput.getInstance(input);
        iti.setNumber(player.phone);
    };

    this.getSuggestions = function (params) {
        vm.searchingUsers = true;
        return Club.API.customGET('players_offline', { search: params })
            .then(function (data) {
                vm.searchingUsers = false;
                return data.map(function (item) {
                    return new PlayerOffline(item);
                });
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
                vm.searchingUsers = false;
            });
    };

    $scope.ngModelOptionsSelected = function (player) {
        vm.search = '';
        if (player.id === vm.user.id) {
            alerts.error('Error!', 'El usuario es el jugador principal');
            return;
        }

        if (!vm.canSave()) {
            alerts.error(
                'Error!',
                `El cupo de ${vm.players_max} jugadores se ecuentra completo!`,
            );
            return;
        }

        vm.players.addPlayer(player);
    };
}
